import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import CardHeader from "@material-ui/core/CardHeader";
import Link from "@material-ui/core/Link";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import Box from "@material-ui/core/Box";
import { loadCSS } from "fg-loadcss";
import PruebaGoogleMaps from "../PruebaGoogleMaps";
import Dialog from "@material-ui/core/Dialog";
import CheckCircleOutlinedIcon from "@material-ui/icons/CheckCircleOutlined";
import Slide from "@material-ui/core/Slide";
import HotelDetails from "../../Components/Hotels/HotelDetails";
import Login from "./Login";
import axios from "axios";
import CircularProgress from "@material-ui/core/CircularProgress";
import FormPax from "./FormPax";
import Button from "@material-ui/core/Button";
import CancelOutlinedIcon from "@material-ui/icons/CancelOutlined";
import { Alert, AlertTitle } from "@material-ui/lab";
import Rating from "@material-ui/lab/Rating";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import WaitBooking from "./WaitBooking";
import NRFMessages from "./NRFMessage";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import { Fragment } from "react";
import { useLocation } from 'react-router-dom';

const useStyles = makeStyles({
  CardTittulo: {
    color: "#016AA2",
    fontFamily: "MontserratSemiBold",
  },
  CardTittuloHab: {
    color: "#757575",
    fontFamily: "MontserratRegular",
  },
  root: {
    maxWidth: "lg",
    backgroundColor: "white",
    padding: 0,
    marginBottom: "1%",
    marginTop: 0,
    marginLeft: 0,
    marginRight: 0,
    borderStyle: "none",
    borderWidth: "1px",
    borderColor: "#F8E8E8",
  },
  cardseccion: {
    maxWidth: "lg",
    padding: 0,
    margin: 0,
    borderStyle: "none",
    borderWidth: "1px",
    borderColor: "#cfd8dc",
    backgroundColor: "white",
  },

  RoomsCard: {
    padding: "1%",
  },
  RoomsCardPrincipal: {
    padding: 0,
    margin: 0,
    backgroundColor: "white",
  },
  RoomsCardAction: {
    padding: 0,
    margin: 0,
    backgroundColor: "#ffe0b2",
  },
  RoomsDescription: {
    paddingTop: "1%",
    paddingLeft: "1%",
    paddingRight: "1%",
  },
  RoomsName: {
    paddingTop: "0.7%",
    paddingRight: "1%",
    paddingBottom: 0,
  },
  RoomsDireccion: {
    flexGrow: 1,
    paddingTop: "0px",
    paddingBottom: "1%",
    direction: "row",
    justify: "center",
    alignItems: "center",
  },
  RoomsContainer: {
    paddingBottom: "0.7%",
    backgroundColor: "#E0E0E0",
  },
  GridImagen: {
    paddingBottom: "0%",
  },
  TituloHotel: {
    color: "#FE5215",
    // fontWeight: 'bolder'
  },
  HotelAddress: {
    color: "#016AA2",
    fontStyle: "oblique",
    verticalAlign: "top",
    paddingBottom: 7,
  },
  HotelDescription: {
    display: "flex",
    alignItems: "center",
    paddingTop: "1%",
    paddingRight: "0.5%",
    height: 70,
    color: "#757575",
  },
  TituloHabitacion: {
    color: "#016AA2",
  },
  DetalleHabitacion: {
    color: "#757575",
  },
  DetalleHabitacionPrecio: {
    color: "black",
    fontWeight: "bold"
  },
  appBar: {
    position: "relative",
    backgroundColor: "#016AA2",
  },
  title: {
    marginLeft: 10,
    flex: 1,
  },
  operador: {
    color: "#E0E0E0",
    fontSize: "9px",
  },
  headerseccion: {
    backgroundColor: "#ef6c00",
    color: "white",
    fontSize: "1.8rem",
  },
  headerhabsub: {
    marginTop: "0px",
    marginBottom: "0px",
    paddingTop: "0px",
    paddingBottom: "0px",
    color: "#016AA2",
    fontFamily: "MontserratRegular",
    backgroundColor: "white",
  },
  headerhab: {
    marginTop: "0px",
    marginBottom: "0px",
    paddingTop: "0px",
    paddingBottom: "0px",
    color: "#016AA2",
    fontFamily: "MontserratSemiBold",
    backgroundColor: "aliceblue",
  },
  headerhabBooking: {
    marginTop: "0px",
    marginBottom: "0px",
    paddingTop: "0px",
    paddingBottom: "0px",
    color: "#016AA2",
    fontFamily: "MontserratSemiBold",
    backgroundColor: "#c8e6c9",
  },
  iconAlert: {
    "& .MuiAlert-icon": {
      fontSize: 55,
    },
    fontSize: "1.3rem",
  },
  titleAlert: {
    "& .MuiAlertTitle": {
      fontSize: "1.8rem",
    },
  },
});

/*  const styles = {
  dialogPaper: {
    width: "800px",
    Height: "800px",
  },
}; */

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function HotelBooking(resultX, i) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [openWait, setOpenWait] = React.useState(false);
  const [openNRF, setOpenNRF] = React.useState(false);
  const [flagAuth, setFlagAuth] = React.useState(false);
  const [flagNRF, setFlagNRF] = React.useState(false);
  const [flagPoliticas, setFlagPoliticas] = React.useState(false);
  const [openDetails, setOpenDetails] = React.useState(false);
  const [policy, setPolicy] = React.useState([]);
  const [notas, setNotas] = React.useState([]);
  const [paxes, setPaxes] = React.useState([]);
  const [login, setLogin] = React.useState([]);
  const [bookingOk, setBookingOk] = React.useState(false);
  const [bookingKO, setBookingaKO] = React.useState(false);
  const [notaBooking, setNotaBooking] = React.useState("");
  const [numeroBooking, setNumeroBooking] = React.useState("");
  const [politicasOnline, setPoliticasOnline] = React.useState("");
  const [notasOnline, setNotasOnline] = React.useState("");
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  console.log('booking');
  console.log(resultX);

  React.useEffect(() => {
    window.scrollTo(0, 0)
    getPolicy();
    creaPaxes();
    const node = loadCSS(
      "https://use.fontawesome.com/releases/v5.12.0/css/all.css",
      document.querySelector("#font-awesome-css")
    );

    return () => {
      node.parentNode.removeChild(node);
    };
  }, []);

    const parseHtml = require("html-react-parser");

  const creaPaxes = () => {
    var Paxes = [];
    console.log("resultX Distri")
    console.log(resultX);
    //distribution: 'hab1=1,2,10,15&hab2=0&hab3=0',
    var dist = [];
    dist.push(resultX.distribution);
    console.log("Distri")
    console.log(dist);
    var nombreHab = resultX.hotel.opcion_nombre;
    // RECORRE CADA UNA DE LAS HABITACIONES+
    var iHab;
  /*   for (iHab = 0; iHab < dist.length; iHab++) {
      if (dist[iHab].split("=")[1] !== 0) {
        var pax = {
          Hab: iHab,
          NombreHabitacion: nombreHab[iHab],
          Regimen: resultX.hotel.Regimen,
          Paxes: [],
        };

        // RECORRE CADA UNA DE LOS DATOS DE LA HABITACION LUEGO DEL =  (1,2,10,15)
        var contenidoHab = dist[iHab].split("=")[1].split(",");
        var ipax;
        for (ipax = 0; ipax < contenidoHab.length; ipax++) {
          switch (ipax) {
            case 0:
              // RECORRE LOS ADULTOS POR CADA HABITACION (1) - (1,2,10,15)
              var ipax0;
              for (ipax0 = 0; ipax0 < contenidoHab[ipax]; ipax0++) {
                pax.Paxes.push({
                  Id: iHab + "-A-" + ipax0,
                  Tipo: "ADULTO",
                  Edad: "",
                  Nombre: "",
                  Apellido: "",
                  Genero: "",
                });
              }
              break;
            // RECORRE LOS NIÑOS  POR CADA HABITACION (2) - (1,2,10,15)
            case 1:
              var ipax1;
              for (ipax1 = 0; ipax1 < contenidoHab[ipax]; ipax1++) {
                pax.Paxes.push({
                  Id: iHab + "-N-" + ipax1,
                  Tipo: "NINO",
                  Edad: contenidoHab[ipax + ipax1 + 1],
                  Nombre: "",
                  Apellido: "",
                  Genero: "",
                });
              }
              break;
            default:
          }
        }
        Paxes.push(pax);
      }
    } */
     iHab = 0;
    if (dist[iHab].split("=")[1] !== 0) {
      var pax = {
        Hab: iHab,
        NombreHabitacion: nombreHab,
        Regimen: resultX.hotel.Regimen,
        Paxes: [],
      };

      // RECORRE CADA UNA DE LOS DATOS DE LA HABITACION LUEGO DEL =  (1,2,10,15)
      var contenidoHab = dist[iHab].split("=")[1].split(",");
      var ipax;
      for (ipax = 0; ipax < contenidoHab.length; ipax++) {
        switch (ipax) {
          case 0:
            // RECORRE LOS ADULTOS POR CADA HABITACION (1) - (1,2,10,15)
            var ipax0;
            for (ipax0 = 0; ipax0 < contenidoHab[ipax]; ipax0++) {
              pax.Paxes.push({
                Id: iHab + "-A-" + ipax0,
                Tipo: "ADULTO",
                Edad: "",
                Nombre: "",
                Apellido: "",
                Genero: "",
              });
            }
            break;
          // RECORRE LOS NIÑOS  POR CADA HABITACION (2) - (1,2,10,15)
          case 1:
            var ipax1;
            for (ipax1 = 0; ipax1 < contenidoHab[ipax]; ipax1++) {
              pax.Paxes.push({
                Id: iHab + "-N-" + ipax1,
                Tipo: "NINO",
                Edad: contenidoHab[ipax + ipax1 + 1],
                Nombre: "",
                Apellido: "",
                Genero: "",
              });
            }
            break;
          default:
        }
      }
    }
      Paxes.push(pax);
    setPaxes(Paxes);
  };

  const getPolicy = () => {
    var NotasTmp = "";
    var PoliticasTmp = "";

 const url = "https://webtravel2-online.com/APIhoteles/api/PoliticasServiciosRetrieve?idEncabezado=" +
      resultX.hotel.idEncabezado +
      "&idCombinacion=" +
      resultX.hotel.idCombinacion +
      "&Operador=" +
      resultX.hotel.operador;
    
    axios
      .get(url)
      .then((response) => {
        if (response.data[0].EnPenalidad) {
          setFlagNRF(true);
        }
        if (response.data[0].Condiciones.length > 0) {
          setFlagPoliticas(true);
          setPolicy(response.data[0].Condiciones);
          for (var i = 0; i < response.data[0].Condiciones.length; i++) {
            PoliticasTmp =
              PoliticasTmp +
              response.data[0].Condiciones[i].Fecha +
              ": " +
              response.data[0].Condiciones[i].Cargo +
              " & ";
          }
        } else {

          var politicas = [];
          if (resultX.hotel.Operador === "ATOM") {
            setFlagPoliticas(true);
            politicas.push({
              Cargo: "",
              Descripcion: "",
              Fecha: "Favor consultar con Atom Travel",
              Habitacion: "",
              Tipo: "",
            })
          } else {
            setFlagPoliticas(false);
            politicas.push({
              Cargo: "",
              Descripcion: "",
              Fecha: "No existen políticas de cancelación.",
              Habitacion: "",
              Tipo: "",
            })
          }
          setPolicy(politicas);
          for (var ii = 0; ii < politicas.length; ii++) {
            PoliticasTmp =
              PoliticasTmp +
              politicas[ii].Fecha +
              ": " +
              politicas[ii].Cargo +
              " & ";
          }
        }
        setNotas(response.data[0].Notas);
        for (var i = 0; i < response.data[0].Notas.length; i++) {
          NotasTmp = NotasTmp + response.data[0].Notas[i].Descripcion + " & ";
        }
        setNotasOnline(NotasTmp);

        setPoliticasOnline(PoliticasTmp);
      })
      .catch((error) => {
        setFlagPoliticas(false);
        var politicas = [];
        if (resultX.hotel.Operador === "ATOM") {
          politicas.push({
            Cargo: "",
            Descripcion: "",
            Fecha: "Favor consultar con Atom Travel",
            Habitacion: "",
            Tipo: "",
          })
        } else {
          politicas.push({
            Cargo: "se cobrará 100% del total de noches",
            Descripcion: "fff",
            Fecha: "ERROR EN WS ----- En gastos desde la reserva",
            Habitacion: "",
            Tipo: "",
          })
        }
        setPolicy(politicas);
        for (var i = 0; i < politicas.length; i++) {
          // PoliticasTmp = PoliticasTmp + policy[i].Fecha + ": " + policy[i].Cargo + " & ";
          PoliticasTmp = PoliticasTmp + politicas[i].Fecha + " " + politicas[i].Cargo + " & ";
        }
        setPoliticasOnline(PoliticasTmp);
      }); //
  };

  const date_diff_indays = (dt1, dt2) => {
    // {resultX.fromX.substring(8, 6) + " / " + resultX.fromX.substring(6, 4) + " / " + resultX.fromX.substring(0, 4)}
    return Math.floor(
      (Date.UTC(
        dt2.substring(0, 4),
        dt2.substring(6, 4) - 1,
        dt2.substring(8, 6)
      ) -
        Date.UTC(
          dt1.substring(0, 4),
          dt1.substring(6, 4) - 1,
          dt1.substring(8, 6)
        )) /
      (1000 * 60 * 60 * 24)
    );
  };

  const handleClickOpenDialog = () => {
    setOpen(true);
  };

  const handleCloseDialog = () => {
    setOpen(false);
  };

  const handleCloseDialogWait = () => {
    setOpenWait(false);
  };

  const handleCloseDialogNRF = () => {
    setOpenNRF(false);
  };

  const handleClickOpenDialogDetails = () => {
    setOpenDetails(true);
  };

  const handleCloseDialogDetails = () => {
    setOpenDetails(false);
  };

  const handleClickCancel = () => {
    resultX.onCancel(false);
  };

  const onClickBooking = () => {
    var claveControl = "SI";

    if (flagNRF) {
      if (login.agencySelected.NOMBRE == "ATOM - RESERVAS") {
        var claveControl = prompt("LA RESERVA ESTA EN PENALIDAD. Ingrese la clave de control");
        if (claveControl != "24twxs") {
          alert("Clave incorrecta")
          claveControl = "NO";
        } else {
          claveControl = "SI";
        }
      } else {
        setOpenNRF(true);
        claveControl = "NO";
        setFlagAuth(false);
      }
    }
    let pp;
    setOpenWait(true);
    paxes.forEach((i) => pp = i.Paxes.filter((x) => x.Nombre === "" || x.Apellido === "" || x.Edad === "" || typeof x.Nombre === "undefined" || typeof x.Apellido === "undefined" || typeof x.Edad === "undefined").length);
    if (pp === 0 && claveControl == "SI") {

      setFlagAuth(false);
      var habs = [];
      var cantAdultos = 0;
      var cantNinos = 0;
      paxes.map((result, i) => {
        let hab = [];
        result.Paxes.map((resultPaxes, i) => {
          let pax = {};
          pax.NOMBRE = resultPaxes.Nombre;
          pax.APELLIDO = resultPaxes.Apellido;
          pax.EDAD = resultPaxes.Edad;
          hab.push(pax);
          if (resultPaxes.Edad === "" || resultPaxes.Edad > 17) {
            cantAdultos = cantAdultos + 1;
          } else {
            cantNinos = cantNinos + 1;
          }
        });
        habs.push({
          ORDEN: i,
          DESCRIPCION: result.NombreHabitacion,
          PASAJEROS: hab,
        });
      });
      console.log(resultX);
      var codigoIbero = "";
      switch (resultX.AgenciaWeb) {
        case "Ibero":
          codigoIbero = "A94502";
          break;
        case "MC":
          codigoIbero = "MC";
          break;
        default:
          codigoIbero = "";
          break;
      }
     /*  if (resultX.AgenciaWeb === "Ibero") {
        codigoIbero = "A94502";
      } */
      var book = {
        ITEMS: [
          {
            HABITACIONES: habs,
            DESCRIPCIONCOMBINACION: resultX.hotel.opcion_nombre,
            IDENCABEZADO: resultX.hotel.idEncabezado,
            IDCOMBINADOS: resultX.hotel.idCombinacion,
            TIPO: "SERVICIO",
            DESCRIPCION: resultX.hotel.nombre,
            FECHAENTRADA: resultX.hotel.fecha_inicio,
            FECHASALIDA: resultX.hotel.fecha_fin,
            CODIGO: resultX.hotel.codigo,
            PROVEEDOR: resultX.hotel.operador,
            CIUDAD: resultX.hotel.destino,
            CIUDADNAME: resultX.hotel.destinonombre,
            OBSERVACIONES: login.mensaje,
            REGIMEN: "",
            PRECIO: resultX.hotel.precio_total,
            MONEDA: resultX.hotel.precio_moneda,
            CATEGORIA: "",
            ADULTOS: cantAdultos,
            NINOS: cantNinos,
            PoliticasOnline: politicasOnline,
            NotasOnline: notasOnline.substring(0, 1400),
          },
        ],
        AGENCIA: [
          {
            NOMBRE: login.agencySelected.NOMBRE,
            NOMBREAGENTE: login.agentSelected.NOMBRE,
            CORREO: "",
            CODIGO: codigoIbero,
          },
        ],
        PASDIRECTO: [
          {
            NOMBRE: login.nombreApellido,
            CELULAR: "",
            TELEFONO: login.telefono,
            CORREO: login.email,
            MENSAJE: login.mensaje,
          },
        ],
        ASIGNADOA: login.registrado ? "AG" : "DI",
        EXPEDIENTEREFERENCIA: "",
        PASSWORD: login.contrasena,
      };

      console.log('book');
      console.log(book);
      var urlBooking = "https://webtravel2-online.com/APIhoteles/api/ReservaServicios";
      if (resultX.AgenciaWeb !== "Ibero" || resultX.AgenciaWeb !== "MC") {
        urlBooking = "https://webtravel2-online.com/APIhoteles/api/ReservaServicios/agencia=Ibero";  
      }
      
      axios
        .post(urlBooking, book)
        //.post('http://localhost:60691/api/Reserva', book)
        .then((response) => {
          console.log('ENTRO EN EL RESPONSE');
          console.log(response.data);
          if (response.data[0].STATUS === "OK") {
            setBookingOk(true);
            setBookingaKO(false);
            if (response.data[0].ITEMRSS[0].NOTAS[0].DESCRIPCION !== "") {
              setNotaBooking(response.data[0].ITEMRSS[0].NOTAS[0].DESCRIPCION);
            }
            setNumeroBooking(response.data[0].EXPEDIENTE);
          } else {
            alert(response.data[0].MENSAJE)
            setBookingaKO(true);
            setBookingOk(false);
          }
          setOpenWait(false);
        })
        .catch((error) => {
          setBookingaKO(true);
          setBookingOk(false);
          setOpenWait(false);
        }); //

    } else {
      setOpenWait(false);
      if (claveControl == "SI") {
        alert("Favor indique los pasajeros.")
      }
    }
  };

  const UpdateLogin = (login) => {
    if (login.flagAuth) {
      if (flagPoliticas === true) {
        setFlagAuth(login.flagAuth);
        setLogin(login);
      } else {
        alert('Error en polítcas.')
      }
    }
  };

  const handleChangePax = (pax) => {
    paxes[
      paxes.findIndex((s) => s.Hab == pax.room.Id.split("-")[0])
    ].Paxes.filter((s) => s.Id == pax.room.Id)[0].Nombre = pax.Nombre;
    paxes[
      paxes.findIndex((s) => s.Hab == pax.room.Id.split("-")[0])
    ].Paxes.filter((s) => s.Id == pax.room.Id)[0].Apellido = pax.Apellido;
    paxes[
      paxes.findIndex((s) => s.Hab == pax.room.Id.split("-")[0])
    ].Paxes.filter((s) => s.Id == pax.room.Id)[0].Edad = pax.Edad;

    setPaxes(paxes);
    //resultX.onChange(paxes)
  };

  return (
    <React.Fragment>
      <Card className={classes.root} variant="outlined">
        {bookingOk === false ? (
          <div></div>
        ) : (
          <React.Fragment>
            {bookingKO === false ? (
              <React.Fragment>
                <Alert
                  severity="success"
                  variant="filled"
                  className={classes.iconAlert}
                >
                  <AlertTitle style={{ fontSize: "1.7rem" }}>
                    Reserva realizada con éxito.
                  </AlertTitle>
                  El número de la reserva es: <strong>{numeroBooking}</strong>
                </Alert>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <Alert severity="warning" variant="filled">
                  <AlertTitle>Ha habido un error en la reserva.</AlertTitle>
                  Favor volver a intentarlo. Disculpe las moletias.
                </Alert>
              </React.Fragment>
            )}
          </React.Fragment>
        )}
      </Card>
      <CardContent className={classes.RoomsCardPrincipal}>
        <Card className={classes.cardseccion} variant="outlined">
          <CardHeader
            className={bookingOk ? classes.headerhabBooking : classes.headerhab}
            title={
              <Typography
                variant="h5"
                gutterBottom
                className={classes.CardTittulo}
              >
                Servicio seleccionado
              </Typography>
            }
          />
          <CardContent className={classes.RoomsCard}>
            <Grid container spacing={1} className={classes.RoomsName}>
              <Grid item xs={3} className={classes.GridImagen}>
                <Paper className={classes.paper}>
                  <CardMedia
                    component="img"
                    alt={resultX.hotel.nombre}
                    height="160"
                    image={
                      resultX.hotel.imagen1 == null
                        ? "./NoImagen.jpg"
                        : resultX.hotel.imagen1
                    }
                    title={resultX.hotel.nombre}
                  />
                </Paper>
              </Grid>
              <Grid item xs={9} className={classes.RoomsDescription}>
                <Grid container spacing={1} className={classes.RoomsName}>
                  <Grid item xs={10}>
                    <Typography variant="h6" className={classes.TituloHotel}>
                      {/* <Link href="#" onClick={handleClickOpenDialogDetails}>  {resultX.hotel.nombreHotel}</Link> */}
                      {resultX.hotel.nombre}
                    </Typography>
                    {/* <Link href="#" onClick={handleClickOpenDialog}> */}
                    <Box display="flex" alignItems="center">
                      <Box>
                        <LocationOnIcon
                          fontSize="small"
                          className={classes.HotelAddress}
                        ></LocationOnIcon>
                      </Box>
                      <Box>
                        <Typography
                          variant="body2"
                          className={classes.HotelAddress}
                        >
                          {resultX.hotel.destinonombre}
                        </Typography>
                      </Box>
                    </Box>
                    {/* </Link> */}
                  </Grid>
                  <Grid item xs={1}>
               {/*      <Typography variant="body2" className={classes.TituloHotel}>
                      {resultX.hotel.categoriaMapeada != "1" &&
                        resultX.hotel.categoriaMapeada != "2" &&
                        resultX.hotel.categoriaMapeada != "3" &&
                        resultX.hotel.categoriaMapeada != "4" &&
                        resultX.hotel.categoriaMapeada != "5" ? <div></div> :
                        <Rating
                          name="size-small"
                          value={parseInt(resultX.hotel.categoriaMapeada)}
                          size="small"
                          readOnly={true}
                          emptyIcon={<StarBorderIcon fontSize="inherit" />}
                        />}
                    </Typography> */}
                    <Typography variant="caption" style={{ color: "#fff" }}>
                      {resultX.hotel.categoria} - {resultX.hotel.Operador}
                    </Typography>
                  </Grid>
                </Grid>
                <Box className={classes.HotelDescription}>
                  <Typography variant="body2">
                    {resultX.hotel.descripcion == null ? (
                      "Sin descripción"
                    ) : resultX.hotel.descripcion.length > 380 ? (
                      <React.Fragment>
                        {parseHtml(
                          String(resultX.hotel.descripcion.substring(0,380))
                        )}{" "}
                       {/*  <Link href="#" onClick={handleClickOpenDialogDetails}>
                          ...más información
                        </Link> */}
                      </React.Fragment>
                    ) : (
                      parseHtml(resultX.hotel.descripcion)
                    )}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        <Card className={classes.cardseccion} variant="outlined">
          <CardHeader
            className={bookingOk ? classes.headerhabBooking : classes.headerhab}
            title={
              <Typography
                variant="h5"
                gutterBottom
                className={classes.CardTittulo}
              >
                Detalle de la Reserva
              </Typography>
            }
          ></CardHeader>
          <CardContent className={classes.RoomsCard}>
            <Grid container spacing={1} className={classes.RoomsName}>
              <Grid
                item
                sm={6}
                style={{ paddingTop: "1%" }}
              >
                <Grid
                  container
                  spacing={1}
                  className={classes.grid}
                  direction="row"
                  justify="space-between"
                  style={{ minHeight: "65px" }}
                  alignItems="flex-start"
                >
                  <Grid item sm={3}>
                    <Paper style={{ textAlign: "center" }} elevation={0}>
                      <Typography
                        variant="subtitle2"
                        gutterBottom
                        className={classes.TituloHabitacion}
                      >
                        Fecha del servicio
                      </Typography>
                      <Box>
                        <Typography variant="body2" gutterBottom className={classes.DetalleHabitacion}>
                          {resultX.hotel.fecha_inicio.substring(8, 6) +
                            " / " +
                            resultX.hotel.fecha_inicio.substring(6, 4) +
                            " / " +
                            resultX.hotel.fecha_inicio.substring(0, 4)}
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>

                  <Grid item sm={3}>
                    <Paper style={{ textAlign: "left" }} elevation={0}>
                      <Typography
                        variant="subtitle2"
                        gutterBottom
                        className={classes.TituloHabitacion}
                      >
                        Opción
                      </Typography>
                      <Box>
                        <Typography variant="body2" gutterBottom className={classes.DetalleHabitacion}>
                          {resultX.hotel.opcion_nombre}
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>

                 {/*  <Grid item sm={3}>
                    <Paper style={{ textAlign: "center" }} elevation={0}>
                      <Typography
                        variant="subtitle2"
                        gutterBottom
                        className={classes.TituloHabitacion}
                      >
                        Fecha de Salida
                      </Typography>
                      <Box>
                        <Typography variant="body2" gutterBottom className={classes.DetalleHabitacion}>
                          {resultX.toX.substring(8, 6) +
                            " / " +
                            resultX.toX.substring(6, 4) +
                            " / " +
                            resultX.toX.substring(0, 4)}
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>

                  <Grid item sm={2}>
                    <Paper style={{ textAlign: "center" }} elevation={0}>
                      <Typography
                        variant="subtitle2"
                        gutterBottom
                        className={classes.TituloHabitacion}
                      >
                        Noches
                      </Typography>
                      <Typography variant="body2" gutterBottom className={classes.DetalleHabitacion}>
                        {date_diff_indays(resultX.fromX, resultX.toX)}
                      </Typography>
                    </Paper>
                  </Grid>

                  <Grid item sm={4}>
                    <Paper style={{ textAlign: "center" }} elevation={0}>
                      <Typography
                        variant="subtitle2"
                        gutterBottom
                        className={classes.TituloHabitacion}
                      >
                        Régimen Alimenticio
                      </Typography>
                      <Typography variant="body2" gutterBottom className={classes.DetalleHabitacion}>
                        {resultX.hotel.Regimen}
                      </Typography>
                    </Paper>
                  </Grid> */}
                </Grid>
              </Grid>

              <Grid
                item
                xs={6}
                style={{ paddingTop: "1%" }}
              >
                <Grid
                  container
                  spacing={1}
                  className={classes.grid}
                  direction="row"
                  justify="space-between"
                  style={{ minHeight: "65px" }}
                  alignItems="flex-start"
                >
                  <Grid item sm={10}>
                    <Paper style={{ textAlign: "left" }} elevation={0}>
                      <Typography
                        variant="subtitle2"
                        gutterBottom
                        className={classes.TituloHabitacion}
                      >
                        {/* Tipo de Habitación */}
                      </Typography>
                      <Typography variant="body2" gutterBottom className={classes.DetalleHabitacion}>
                        {resultX.hotel.DescripcionCombinacion}
                      </Typography>
                    </Paper>
                  </Grid>
                  <Grid item sm={2}>
                    <Paper style={{ textAlign: "right" }} elevation={0}>
                      <Typography
                        variant="subtitle2"
                        gutterBottom
                        className={classes.TituloHabitacion}
                      >
                        Precio
                      </Typography>
                      <Typography variant="body2" gutterBottom className={classes.DetalleHabitacionPrecio}>
                        {resultX.hotel.precio_moneda} {resultX.hotel.precio_total}
                      </Typography>
                    </Paper>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>

        <Card className={classes.root} variant="outlined">
          <CardHeader
            className={
              bookingOk ? classes.headerhabBooking : classes.headerhab
            }
            title={
              <Typography
                variant="h5"
                gutterBottom
                className={classes.CardTittulo}
              >
                Datos de los Pasajeros
              </Typography>
            }
          />
          <CardContent className={classes.RoomsCardPrincipal}>
            <Grid container spacing={1} className={classes.RoomsName}>
              <Grid item xs={12}>
                {paxes.map((resultX, i) => (
                  <Card className={classes.cardseccion} variant="outlined" id={i}>
                    <CardHeader
                      className={classes.headerhabsub}
                      title={
                        <Typography
                          variant="h6"
                          gutterBottom
                          className={classes.CardTittuloHab}
                        >
                          {resultX.NombreHabitacion}
                        </Typography>
                      }
                    />
                    <CardContent className={classes.RoomsCard}>
                      {resultX.Paxes.map((resultY, i) => (
                        <FormPax
                          key={i}
                          room={resultY}
                          onChange={handleChangePax}
                          bookingOkf={bookingOk}
                        ></FormPax>
                      ))}
                    </CardContent>
                  </Card>
                ))}
              </Grid>
            </Grid>
          </CardContent>
        </Card>

        <React.Fragment>
          <Card className={classes.cardseccion} variant="outlined">
            <CardHeader
              className={
                bookingOk ? classes.headerhabBooking : classes.headerhab
              }
              title={
                <Typography
                  variant="h5"
                  gutterBottom
                  className={classes.CardTittulo}
                >
                  Políticas de Cancelación
                </Typography>
              }
            />
            <CardContent className={classes.RoomsCard}>
              <Grid container spacing={1} className={classes.RoomsName}>
                <Grid item xs={12}>
                  {policy.length > 0 ? (
                    <div style={{ alignItems: "center" }}>
                      {policy.map((resultX, i) => (
                        <Typography variant="subtitle2" gutterBottom>
                          {resultX.Fecha}: {resultX.Cargo}
                        </Typography>
                      ))}
                      {flagNRF ? (
                        <Fragment>
                          <br></br>
                          <Typography variant="h6" gutterBottom style={{ color: "red", textAlign: "center" }} >
                            La reserva ya se encuentra en penalidad.
                          </Typography>
                          <br></br>
                        </Fragment>
                      ) :
                        <div></div>}
                    </div>
                  ) : (
                    <CircularProgress />
                  )}
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </React.Fragment>

        {notas.length > 0 ? (
          <React.Fragment>
            <Card className={classes.cardseccion} variant="outlined">
              <CardHeader
                className={
                  bookingOk ? classes.headerhabBooking : classes.headerhab
                }
                title={
                  <Typography
                    variant="h5"
                    gutterBottom
                    className={classes.CardTittulo}
                  >
                    Nota Importantes de Confirmación
                  </Typography>
                }
              />
              <CardContent className={classes.RoomsCard}>
                <Grid container spacing={1} className={classes.RoomsName}>
                  <Grid item xs={12}>
                    <Typography
                      variant="subtitle2"
                      gutterBottom
                      className={classes.TituloHabitacion}
                    ></Typography>
                    {notas.length > 0 ? (
                      <div style={{ alignItems: "center" }}>
                        {notas.map((resultX, i) => (
                          /*  <Typography variant="subtitle2" gutterBottom>
                               {encodeHTMLEntities(resultX.Descripcion)}
                                                       </Typography> */
                          // <div dangerouslySetInnerHTML={{__html: resultX.Descripcion}} />
                          <React.Fragment>
                            {resultX.Descripcion !== "Con Disponibilidad" &&
                              resultX.Descripcion !== "BookingCode" ? (
                              parseHtml(resultX.Descripcion)
                            ) : (
                              <div></div>
                            )}
                          </React.Fragment>
                        ))}
                      </div>
                    ) : (
                      <CircularProgress />
                    )}
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </React.Fragment>
        ) : (
          <div></div>
        )}

        {notaBooking != "" ? (
          <React.Fragment>
            <Card className={classes.cardseccion} variant="outlined">
              <CardHeader
                className={classes.headerhabBooking}
                title="Notas importante de la reserva"
              />
              <CardContent className={classes.RoomsCard}>
                <Grid container spacing={1} className={classes.RoomsName}>
                  <Grid item xs={12}>
                    {notaBooking}
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </React.Fragment>
        ) : (
          ""
        )}
      </CardContent>

      {bookingOk === false ? (
        <React.Fragment>


          <Card className={classes.root} variant="outlined">
            <CardHeader
              className={
                bookingOk ? classes.headerhabBooking : classes.headerhab
              }
              title={
                <Typography
                  variant="h5"
                  gutterBottom
                  className={classes.CardTittulo}
                >
                  Responsable de la Reserva
                </Typography>
              }
            />
            <CardContent className={classes.RoomsCardPrincipal}>
              <Grid container spacing={1} className={classes.RoomsName}>
                <Grid item xs={12}>
                  <Login onChange={UpdateLogin} AgenciaWeb={resultX.AgenciaWeb}></Login>
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          <Box
            display="flex"
            flexDirection="row-reverse"
            p={1}
            m={1}
            bgcolor="background.paper"
          >
            <Box p={1}>
              <Button
                variant="contained"
                color="primary"
                disabled={!flagAuth}
                onClick={onClickBooking}
                style={{ backgroundColor: "#016AA2" }}
                className={classes.button}
                endIcon={<CheckCircleOutlinedIcon />}
              >
                Reservar
              </Button>
            </Box>
            <Box p={1}>
              <Button
                variant="contained"
                // color="secondary"
                className={classes.button}
                startIcon={<CancelOutlinedIcon />}
                onClick={handleClickCancel}
              >
                Volver atrás
              </Button>
            </Box>
          </Box>
        </React.Fragment>
      ) : (
        ""
      )}
      <Dialog
        fullWidth
        maxWidth="sm"
        open={open}
        onClose={handleCloseDialog}
        TransitionComponent={Transition}
      >
        <PruebaGoogleMaps hotel={resultX.hotel} bar={true}></PruebaGoogleMaps>
      </Dialog>

      <Dialog
        fullWidth
        maxWidth="lg"
        open={openDetails}
        onClose={handleCloseDialogDetails}
        TransitionComponent={Transition}
      >
        <HotelDetails
          hotel={resultX}
          bar={false}
          zoneName={resultX.zoneName}
          countryFlag={resultX.countryFlag}
        ></HotelDetails>
      </Dialog>

      {/* MODAL DE LOADING RESERVA */}
      <Dialog
        disableBackdropClick
        disableEscapeKeyDown
        fullScreen={fullScreen}
        open={openWait}
        onClose={handleCloseDialogWait}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <DialogContentText>
            <WaitBooking
              zoneName={resultX.zoneName}
              countryFlag={resultX.countryFlag}
              hotelName={resultX.hotel.nombreHotel}
              AgenciaWeb={resultX.AgenciaWeb}
            ></WaitBooking>
          </DialogContentText>
        </DialogContent>
      </Dialog>

      {/* MODAL DE RESERVA EN PENALIDAD*/}
      <Dialog
        fullScreen={fullScreen}
        open={openNRF}
        onClose={handleCloseDialogNRF}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <DialogContentText>
            <NRFMessages
              zoneName={resultX.zoneName}
              countryFlag={resultX.countryFlag}
              hotelName={resultX.hotel.nombreHotel}
            ></NRFMessages>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}
